module.exports = __webpack_public_path__ + "application/directives/text-editor/text-editor.template.html";